import ContestWork from '@/apps/ContestWork'
import React from 'react'

const ContestWorkBody = (): React.ReactElement => {
  return <ContestWork />
}

export default ContestWorkBody
